import type { FeatureGroup, Plan } from '@hotjar/webapp/domains/revenue/plan/types';
import type { SiteAccountDTO, OwnedAccountDTO } from '@hotjar/account';
import { PlanSelectDropdown as LegacyPlanSelectDropdown } from '@hotjar/webapp/features/Billing/PlanSelectDropdown/LegacyPlanSelectDropDown/PlanSelectDropdown';

export interface PlanSelectDropdownProps {
  account: OwnedAccountDTO | SiteAccountDTO;
  activePlanId?: string;
  onChange: (params: Plan) => void;
  featureGroupFilter?: FeatureGroup;
  hidePlanBadges?: boolean;
}

export const PlanSelectDropdown = (props: PlanSelectDropdownProps): JSX.Element => {
  return <LegacyPlanSelectDropdown {...props} />;
};
